import { ArrowRightLeft, FileText, Plus, Search } from 'lucide-react';

import { ShortcutButton } from '@/components/keyboard/ShortcutIndicator';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface FundInvestorsToolbarProps {
  searchTerm: string;
  loading: boolean;
  isTransferConfigured: boolean;
  hasTransferCandidates: boolean;
  onSearchTermChange: (value: string) => void;
  onRefresh: () => void;
  onOpenCapitalAccounts: () => void;
  onAddInvestor: () => void;
  onOpenTransferModal: () => void;
}

function transferButtonTitle(
  isTransferConfigured: boolean,
  hasTransferCandidates: boolean
): string {
  if (!isTransferConfigured) return 'Transfer action is not configured';
  if (!hasTransferCandidates) {
    return 'Transfer requires an investor with an active commitment in this fund';
  }
  return 'Transfer investor to another investor';
}

export function FundInvestorsToolbar({
  searchTerm,
  loading,
  isTransferConfigured,
  hasTransferCandidates,
  onSearchTermChange,
  onRefresh,
  onOpenCapitalAccounts,
  onAddInvestor,
  onOpenTransferModal,
}: FundInvestorsToolbarProps) {
  return (
    <div className="flex items-center justify-between">
      <div />
      <div className="flex items-center gap-2">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 transform text-muted-foreground" />
          <Input
            placeholder="Search investors..."
            value={searchTerm}
            onChange={(event) => onSearchTermChange(event.target.value)}
            className="w-64 pl-9"
          />
        </div>

        <Button
          variant="outline"
          size="sm"
          onClick={onRefresh}
          disabled={loading}
          aria-label="Refresh investors"
          title="Refresh investors"
        >
          <Search className="h-4 w-4" />
        </Button>

        <Button variant="outline" size="sm" onClick={onOpenCapitalAccounts}>
          <FileText className="h-4 w-4" />
          Capital Accounts
        </Button>

        <ShortcutButton shortcut={{ key: 'i' }} onClick={onAddInvestor}>
          <Plus className="h-4 w-4" />
          Add Investors
        </ShortcutButton>

        <Button
          variant="outline"
          size="sm"
          onClick={onOpenTransferModal}
          disabled={loading || !isTransferConfigured || !hasTransferCandidates}
          title={transferButtonTitle(
            isTransferConfigured,
            hasTransferCandidates
          )}
        >
          <ArrowRightLeft className="h-4 w-4" />
          Transfer Investor
        </Button>
      </div>
    </div>
  );
}
